// Lib
import { put, takeEvery } from 'redux-saga/effects';
import type { Action } from 'redux-actions';

// Api
import client from '@api';
import { ErrorCategory, handleError } from '@services/errorService';

// Actions
import { SetLoading } from '@actions/loading';
import { GetProducts, SetProducts } from '@actions/products';

// Graph
import { getProducts } from '../graphql/queries/products';

// Types
interface ProductsInput {
  skip?: number;
  limit?: number;
  [key: string]: unknown;
}

interface Product {
  _id: string;
  [key: string]: unknown;
}

function* getProductsSaga({
  payload,
}: Action<ProductsInput>): Generator<unknown, void, unknown> {
  try {
    yield put(SetProducts({ isLoading: true }));
    const response = yield client().query({
      query: getProducts,
      variables: { input: payload },
      fetchPolicy: 'no-cache',
    });

    const products = (response as { data: { products: Product[] } }).data
      .products;

    yield put(
      SetProducts({
        products,
        isLoading: false,
        hasNext: products?.length === 10,
      }),
    );

    yield put(SetLoading(false));
  } catch (error) {
    handleError(error, { category: ErrorCategory.GRAPHQL, silent: true });
    yield put(SetProducts({ isLoading: false }));
  }
}

function* productsSaga(): Generator<unknown, void, unknown> {
  yield takeEvery(GetProducts, getProductsSaga);
}

export default productsSaga;
